import { RangePreset } from '../types';

export interface RangePresetValues {
  today: number;
  week: number;
  month: number;
}

/**
 * Calculates the value and display value based on the selected range preset
 */
export const getRangePresetValue = (
  rangePreset: RangePreset,
  values: RangePresetValues,
): { value: number; displayValue: string } => {
  const { today, week, month } = values;

  switch (rangePreset) {
    case 'TODAY':
      return {
        value: today,
        displayValue: String(today),
      };
    case 'THIS_WEEK':
      return {
        value: week,
        displayValue: week.toFixed(2),
      };
    case 'THIS_MONTH':
      return {
        value: month,
        displayValue: month.toFixed(2),
      };
    default:
      return {
        value: today,
        displayValue: String(today),
      };
  }
};

/**
 * Formats subtitle with Today, Week, and Month values
 */
export const formatRangeSubtitle = (values: RangePresetValues): string => {
  return `Today: ${values.today} • Week: ${values.week.toFixed(2)} • Month: ${values.month.toFixed(2)}`;
};

